<template>
  <div class="actions">
    <a
      href="javascript:void(0)"
      class="btn btn-primary"
      @click.prevent="setSelected"
      data-toggle="modal"
      data-target="#update-anti-parasitaire"
    ><i class="icofont icofont-pencil" /></a>
    <a
      href="javascript:void(0)"
      class="btn btn-third"
      @click.prevent="deleting"
    ><i class="icofont icofont-close" /></a>
  </div>
</template>
  
  <script>
  import {mapGetters, mapMutations} from 'vuex'
  import { DELETE_ANTI_PARASITAIRE } from '../../../../graphql/sanitaire';
  export default {
      props: {object: {type: Object, required: true}},
      data(){
          return{
  
          }
      },
      methods: {
          ...mapMutations({
              setSelectedRace: 'SET_SELECTED_OBJECT',
          }),
          setSelected(){
              this.setSelectedRace(this.object)
          },
          deleting(){
              this.$apollo.mutate({
                  mutation: DELETE_ANTI_PARASITAIRE,
                  variables: {
                      "uid": this.object.uid
                  },
                  update: (data) => {
                      if(data) console.log(`Anti parasitaire ${this.object.libelle} at ${this.object.uid} deleted successfully`)
                      else console.log(`Error in deletting anti parasitaire ${this.object.libelle}`)
                  }
                }).then(() => {
                  
                })
          }
      },
      computed: {
          ...mapGetters({
  
          })
      }
  }
  </script>
  
  <style>
  
  </style>